import React, { useRef } from 'react';
import { Formik, Form, FormikHelpers, FormikProps } from 'formik';
import { Box, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import * as Yup from 'yup';
import { InputCustom, ButtonCustom } from '../UI';
import AuthLinks from '../authBottomLinks';
import { Captcha, CaptchaRef } from '../captcha';

interface CaptchaFormProps {
  onNext: () => void;
}

interface FormValues {
  captcha: string;
}

const link1 = '/signUp';
const link2 = '/signUp';
const linkName1 = 'Нет аккаунта?';
const linkName2 = 'Зарегистрироваться';

const validationSchema = Yup.object().shape({
  captcha: Yup.string().required('Введите капчу'),
});

export const CaptchaForm: React.FC<CaptchaFormProps> = ({ onNext }) => {
  const captchaRef = useRef<CaptchaRef>(null);

  const handleSubmit = (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
    formikHelpers.setSubmitting(true);
    if (captchaRef.current && captchaRef.current.validateCaptcha(values.captcha)) {
      onNext();
    } else {
      formikHelpers.setErrors({ captcha: 'Неверная капча, попробуйте снова' });
      if (captchaRef.current) {
        captchaRef.current.refreshCaptcha();
      }
    }
    formikHelpers.setSubmitting(false);
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="100%"
        height="100vh"
        padding="101px 0 110px"
        maxW="480px"
      >
        <Formik
          initialValues={{ captcha: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, handleChange }: FormikProps<FormValues>) => (
            <Form>
              <Heading mb={6} fontSize="28px">
                Введите символы с картинки
              </Heading>
              <InputCustom
                name="captcha"
                value={values.captcha}
                onChange={handleChange}
                errorMessage={touched.captcha && errors.captcha}
                placeholder="Символы с картинки"
              />
              <Captcha ref={captchaRef} />
              <ButtonCustom variant="withBackground" mt={4} w="full" type="submit">
                Далее
              </ButtonCustom>
            </Form>
          )}
        </Formik>
        <AuthLinks link1Name={linkName1} link1Url={link1} link2Name={linkName2} link2Url={link2} />
      </Box>
    </motion.div>
  );
};
